import { motion } from 'framer-motion'
import { Heart, Target, MessageCircle, TrendingUp } from 'lucide-react'

const reasons = [
  {
    icon: Heart,
    title: 'Személyes hozzáállás',
    description: 'Nem vagy egy szám a rendszerben. Minden ügyféllel egyenként foglalkozom.',
  },
  {
    icon: Target,
    title: 'KKV fókusz',
    description: 'Tudom, milyen kihívásokkal néz szembe egy kis- és középvállalkozás.',
  },
  {
    icon: MessageCircle,
    title: 'Érthető kommunikáció',
    description: 'Nem használok felesleges szakmai zsargont. Mindent érthetően elmagyarázok.',
  },
  {
    icon: TrendingUp,
    title: 'Eredményközpontú gondolkodás',
    description: 'Az a célom, hogy neked több ügyfeled és bevételed legyen.',
  },
]

const WhyChooseMe = () => {
  return (
    <section id="rolam" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image side */}
          <motion.div
            className="relative"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="relative">
              <div className="absolute -inset-4 bg-coffee-100 rounded-3xl -rotate-3" />
              <img
                src="https://customer-assets.emergentagent.com/job_kv-awakens/artifacts/uspkk5dy_638011121_4333328830233389_8854683071554167557_n.jpg"
                alt="Varga Krisztina - KV Studio"
                className="relative rounded-2xl w-full h-[400px] md:h-[500px] object-cover object-top shadow-xl"
                loading="lazy"
              />
              
              {/* Floating quote */}
              <motion.div
                className="absolute -bottom-6 -right-6 md:bottom-8 md:-right-8 bg-coffee-900 text-cream p-6 rounded-2xl max-w-[260px] shadow-xl"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3 }}
              >
                <p className="font-accent text-xl leading-relaxed">
                  "Nem elég jelen lenni – látszani is kell."
                </p>
                <p className="text-coffee-300 text-sm mt-2">– Krisztina</p>
              </motion.div>
            </div>
          </motion.div>

          {/* Content side */}
          <div className="space-y-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <span className="text-coffee-600 text-sm font-medium tracking-widest uppercase block mb-4">
                Miért engem válassz?
              </span>
              <h2 className="font-heading text-4xl md:text-5xl font-bold text-coffee-900 mb-6">
                Varga Krisztina vagyok
              </h2>
              <p className="text-lg text-coffee-600 leading-relaxed">
                Szenvedélyem a kis- és középvállalkozások sikertörténeteinek megírása. 
                Hiszem, hogy minden vállalkozás megérdemli, hogy látható legyen online – 
                és segítek, hogy ez a Te vállalkozásoddal is megtörténjen.
              </p>
            </motion.div>

            {/* Reasons grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4">
              {reasons.map((reason, index) => {
                const Icon = reason.icon
                return (
                  <motion.div
                    key={reason.title}
                    className="space-y-3"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.1 }}
                  >
                    <div className="w-12 h-12 bg-coffee-100 rounded-xl flex items-center justify-center">
                      <Icon size={24} className="text-coffee-600" />
                    </div>
                    <h3 className="font-heading text-lg font-semibold text-coffee-900">
                      {reason.title}
                    </h3>
                    <p className="text-coffee-600 text-sm leading-relaxed">
                      {reason.description}
                    </p>
                  </motion.div>
                )
              })}
            </div>

            {/* CTA */}
            <motion.div
              className="pt-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
            >
              <button
                onClick={() => {
                  const el = document.querySelector('#kapcsolat')
                  if (el) el.scrollIntoView({ behavior: 'smooth' })
                }}
                className="inline-flex items-center gap-2 bg-coffee-900 text-cream px-8 py-4 rounded-full font-semibold hover:bg-coffee-800 transition-colors duration-200"
                data-testid="why-choose-me-cta"
              >
                Ismerj meg jobban
              </button>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WhyChooseMe
